import instance from "../api/api";

const getJobLogs = async (job_id, dateRange, page_number, logType) => {
  const body = {
    job_id: job_id,
    start_date: dateRange[0].startDate,
    end_date: dateRange[0].endDate,
    page_number: page_number,
    log_level: logType
  };
  const response = await instance.post(`/get-job-logs`, body);
  return response.data;
}

const getTaskLogs = async (task_id, page_number) => {
  const body = {
    task_id: task_id,
    page_index: page_number - 1,
    page_size: 10
  };
  const response = await instance.post(`/get-task-logs`, body);
  return response.data;
}

export { getJobLogs, getTaskLogs };


